import { ITimerMarkStatus } from 'ws-voice-infinity-global-module/lib/interfaces';
import { TypeService } from 'ws-voice-infinity-global-module/lib/services';

export enum TimerMarkStatusEnum {
    NORMAL = 'NORMAL',
    NEAR_DEADLINE = 'NEAR_DEADLINE',
    DEADLINE_REACHED = 'DEADLINE_REACHED',
}

const TIMER_MARK_STATUS: ITimerMarkStatus = {
    NORMAL: {
        name: 'Всё хорошо',
        value: 'NORMAL',
    },
    NEAR_DEADLINE: {
        name: 'Приближается срок',
        value: 'NEAR_DEADLINE',
    },
    DEADLINE_REACHED: {
        name: 'Просрочен',
        value: 'DEADLINE_REACHED',
    },
};

export default TIMER_MARK_STATUS;

export const TimerMarkStatusType = TypeService.createEnum<TimerMarkStatusEnum>(TimerMarkStatusEnum, 'TimerMarkStatusEnum');
